import styled from 'styled-components';
import { Box } from '@mui/material';

export const SearchInputStyled = styled(Box)`
.formControlWidth{
width:30%;

}
.searchTextBox
{
  width:100%;
}
`;
